import { useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '@/lib/firebase';

// Visitas anônimas ao site público inteiro (siteVisits/{dia} no Firestore,
// lidas só pelo admin). Quem soma é a callable registerSiteVisit
// (functions/siteVisits.js) — o navegador só avisa "abri o site" e se é a
// primeira vez dele hoje.
//
// - visita: 1x por aba (sessionStorage) — navegar entre páginas ou recarregar
//   não conta de novo.
// - visitante único do dia: o localStorage guarda só a data da última visita
//   contada — nenhum identificador do visitante (ver seção 9 da Política de
//   Privacidade).
//
// Mesmas exclusões do useWebViewCounter: robôs recebem do renderForBots uma
// página sem React, navigator.webdriver é ignorado e em desenvolvimento não
// conta.

const SESSION_KEY = 'joyn_site_visit_session';
const LAST_DAY_KEY = 'joyn_last_visit_day';
// Brasil sem horário de verão desde 2019 — mesmo offset da function.
const SP_OFFSET_MS = -3 * 60 * 60 * 1000;

const registerSiteVisitCallable = httpsCallable(functions, 'registerSiteVisit');

let countedThisLoad = false;

function saoPauloDay() {
  return new Date(Date.now() + SP_OFFSET_MS).toISOString().slice(0, 10);
}

function getItem(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function setItem(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    // storage indisponível — segue sem marca
  }
}

export function useSiteVisitCounter() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (countedThisLoad) return;
    countedThisLoad = true;
    if (navigator.webdriver) return;
    if (getItem(sessionStorage, SESSION_KEY)) return;
    setItem(sessionStorage, SESSION_KEY, '1');

    const today = saoPauloDay();
    const newVisitor = getItem(localStorage, LAST_DAY_KEY) !== today;
    registerSiteVisitCallable({ newVisitor })
      .then(({ data }) => {
        // Se não contou (limite do servidor), tenta o "único" numa próxima visita.
        if (newVisitor && data?.counted) setItem(localStorage, LAST_DAY_KEY, today);
      })
      .catch(() => {
        // contador nunca pode atrapalhar a página
      });
  }, []);
}
